export default ['Resty', 'SectorDataLoader', (Resty, SectorDataLoader) => {
  return Resty('building_sectors', klass => {
    Object.assign(klass, {
      getFormData(id) {
        return SectorDataLoader('building', klass.fetchOne(id));
      }
    });
  });
}]
